import { action, makeAutoObservable } from "mobx";

import RootContext from "@client/context/RootContext";
import {
	persistVendorSortToStorage,
	readVendorSortFromStorage,
} from "@client/helpers/vendor-sort-storage";

const NOTIFICATION_LAST_CONTENT_KEY = "notification_last_content";
const SEARCH_TERM_MIN_LENGTH = 5;

export const ANIMATION_CONSTANTS = {
	ORDER_DONE_ANIMATION_DURATION: 400,
	ORDER_DONE_ANIMATIoN_DURATION_2: 200,
	NEW_ORDER_FLASH_DURATION: 0.75 * 8 * 1000,
	ORDER_APPEARANCE: {
		y: -200,
		x: 0,
		width: 0,
		height: 0,
	},
};

export class LayoutStore {
	ordersAnimation1: number[] = [];
	ordersAnimation2: number[] = [];

	bodyModifierTop = 0;

	isDashboardActive = false;

	isNewOrder = false;
	sort: [number, number, number] = [0, 0, 0];
	sort_search: [number, number, number] = [0, 0, 0];

	constructor(private rootContext: RootContext) {
		makeAutoObservable(this);

		this.sort = readVendorSortFromStorage(false);
		this.sort_search = readVendorSortFromStorage(true);
	}

	public setHasCollectedOrder = (orderId: number) => {
		this.ordersAnimation1.push(orderId);

		setTimeout(() => {
			this.ordersAnimation2.push(orderId);

			setTimeout(() => {
				this.ordersAnimation1.splice(this.ordersAnimation1.indexOf(orderId), 1);
				this.ordersAnimation2.splice(this.ordersAnimation2.indexOf(orderId), 1);
			}, ANIMATION_CONSTANTS.ORDER_DONE_ANIMATIoN_DURATION_2);
		}, ANIMATION_CONSTANTS.ORDER_DONE_ANIMATION_DURATION);
	};

	/* #region Search */
	searchTerm = "";
	searchTermError = "";
	showSearchResults = false;
	isSearchInputFocused = false;
	@action public setShowSearchResults = (value: boolean) =>
		(this.showSearchResults = value);

	public setBodyModifierTop = (newTop: number) =>
		(this.bodyModifierTop = newTop);

	public validateSearchTerm = (value: string): boolean => {
		const trimmedValue = value.trim();
		const isValid = trimmedValue.length >= SEARCH_TERM_MIN_LENGTH;

		this.searchTermError = isValid
			? ""
			: `Please input at least ${SEARCH_TERM_MIN_LENGTH} characters`;

		return isValid;
	};

	@action public searchInput_focus = () => (this.isSearchInputFocused = true);
	@action public searchInput_blur = () => (this.isSearchInputFocused = false);
	public setSearchTerm = (value: string) => {
		this.searchTerm = value;

		this.rootContext.vendorStore.startPollingInterval();

		if (!value) {
			this.setShowSearchResults(false);
		}
	};
	public submitSearch = () => {
		if (!this.validateSearchTerm(this.searchTerm)) {
			return;
		}

		this.searchInput_blur();

		this.rootContext.vendorStore.getVendorAndActiveOrders({
			searchTerm: this.searchTerm,
		});
	};
	/* #endregion Search */

	public setisDashboardActive = (value: boolean) =>
		(this.isDashboardActive = value);

	public setIsNewOrder = (value: boolean) => (this.isNewOrder = value);

	public setSort = (sort: [number, number, number]) => {
		if (this.showSearchResults) {
			this.sort_search = sort;
		} else {
			this.sort = sort;
		}

		persistVendorSortToStorage(sort, this.showSearchResults);

		this.rootContext.vendorStore.getVendorAndActiveOrders({
			searchTerm: this.showSearchResults ? this.searchTerm : undefined,
		});
	};

	// Check if notification content has changed
	public hasNotificationContentChanged(
		title: string,
		message: string
	): boolean {
		const lastContent = localStorage.getItem(NOTIFICATION_LAST_CONTENT_KEY);
		const currentContent = JSON.stringify({ title, message });

		localStorage.setItem(NOTIFICATION_LAST_CONTENT_KEY, currentContent);

		return lastContent !== currentContent;
	}
}
